
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.66675 1.66669H8.00008C3.83341 1.66669 2.16675 3.33335 2.16675 7.50002V12.5C2.16675 16.6667 3.83341 18.3334 8.00008 18.3334H13.0001C17.1667 18.3334 18.8334 16.6667 18.8334 12.5V10.8334","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.8666 2.51669L7.2999 9.08336C7.0499 9.33336 6.7999 9.82503 6.7499 10.1834L6.39157 12.6917C6.25823 13.6 6.8999 14.2334 7.80823 14.1084L10.3166 13.75C10.6666 13.7 11.1582 13.45 11.4166 13.2L17.9832 6.63336C19.1166 5.50003 19.6499 4.18336 17.9832 2.51669C16.3166 0.850027 14.9999 1.38336 13.8666 2.51669Z","stroke":"currentColor","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.925 3.45831C13.4834 5.44998 15.0417 7.00831 17.0417 7.57498","stroke":"currentColor","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    